import type { RunState } from "../domain/types/index.js";
import { CURRENT_RESULT_SCHEMA } from "./playLogSchema.js";

export { CURRENT_RESULT_SCHEMA, LEGACY_RESULT_SCHEMA } from "./playLogSchema.js";

export type RunOutcome = "clear" | "gameover" | "abandoned";

export type ResultPayload = {
  outcome: RunOutcome;
  clearedNodeCount: number;
  finalFatigue: number;
  finalNodeId: string;
  resultSchema: typeof CURRENT_RESULT_SCHEMA;
  elapsedSeconds: number;
  deck: Array<{ cardId: string; quantity: number }>;
};

export function endNodeId(run: RunState): string {
  return run.activeCase?.nodeId ?? run.currentNodeId;
}

function deckSnapshot(run: RunState): Array<{ cardId: string; quantity: number }> {
  const counts = new Map<string, number>();
  for (const card of [run.deck, run.hand, run.discard, run.inPlay, run.aside, run.caseExcluded ?? []].flat()) {
    counts.set(card.cardId, (counts.get(card.cardId) ?? 0) + 1);
  }
  return [...counts.entries()]
    .map(([cardId, quantity]) => ({ cardId, quantity }))
    .sort((a, b) => a.cardId.localeCompare(b.cardId));
}

export function toResultPayload(run: RunState, outcome: RunOutcome): ResultPayload {
  return {
    outcome,
    clearedNodeCount: run.clearedNodeIds.length,
    finalFatigue: run.fatigue,
    finalNodeId: endNodeId(run),
    resultSchema: CURRENT_RESULT_SCHEMA,
    elapsedSeconds: Math.max(0, Math.round((Date.now() - (run.startedAt ?? Date.now())) / 1000)),
    deck: deckSnapshot(run),
  };
}
